import { Box, Typography } from "@mui/material";
import React from "react";
import CollapsibleTypography from "../../generics/components/collapsible-typography";

interface AnalysisSummaryProps {
  title?: string;
  description: string;
}

export default function AnalysisSummary(props: AnalysisSummaryProps) {
  const { 
    title = "Executive Summary", 
    description="" 
  } = props;
  return (
    <>
      <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 500,fontSize: "20px"}}>
        {title}
      </Typography>
      <CollapsibleTypography
        quote={description}
        isAnalysis = {true}
        quouteCollapseLength={450}
        style={{fontSize:'15px', color: 'rgba(0, 0, 0, 0.87)', fontWeight:500,whiteSpace: 'pre-line'}}
      />
    </>
  )
}
